export function mergeAutocompleteMainTextIntoAddressLine1(detailsLine1, mainText) {
  if (!mainText) return detailsLine1 || '';
  const hasDigit = (s) => /\d/.test(s || '');
  if (hasDigit(mainText) && !hasDigit(detailsLine1)) return mainText;
  return detailsLine1 || '';
}

export function cityFromUsAutocompleteSecondaryText(countryCode, secondaryText, detailsCity) {
  if (countryCode !== 'US' || !secondaryText) return detailsCity;
  const parts = secondaryText
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  if (parts.length >= 2) {
    for (let i = parts.length - 1; i >= 1; i--) {
      if (/^[A-Z]{2}($|\s)/.test(parts[i])) {
        return parts[i - 1];
      }
    }
    if (parts.length === 2 && /^[A-Z]{2}$/.test(parts[1])) {
      return parts[0];
    }
  }
  return detailsCity;
}

export function applyResolvedPlaceToAddress(resolved, prediction, formCountryCode) {
  if (!resolved) return null;
  const main = prediction && prediction.structured_formatting && prediction.structured_formatting.main_text;
  const secondary =
    prediction && prediction.structured_formatting && prediction.structured_formatting.secondary_text;
  const googleCountry = resolved.countryCode || formCountryCode;

  const addressLine1 = mergeAutocompleteMainTextIntoAddressLine1(resolved.addressLine1, main);
  const city = cityFromUsAutocompleteSecondaryText(googleCountry || formCountryCode, secondary, resolved.city);

  return {
    ...resolved,
    addressLine1,
    city,
  };
}
